import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import { Box, Typography } from "@mui/material";
import { FC, memo, useCallback, useMemo } from "react";

import { useStore } from "../../../hooks";
import { ISellerToken } from "../../../store/seller-tokens-store";
import StyledButton from "../../ui/StyledButton";
import styles from "../styles";

interface ITableHeader {
  data: ISellerToken;
}

const tokenFieldNames = [
  "sellerToken",
  "sellerId",
  "sellerApiKey",
  "sellerIdPerfomance",
  "sellerSecretPerfomance",
];

const SellerTokenData: FC<ITableHeader> = ({ data }) => {
  const { popupStore, notificationStore } = useStore();

  const tokens = Object.fromEntries(
    Object.entries(data).filter(([key]) => tokenFieldNames.includes(key))
  );

  const text = useMemo(() => Object.keys(tokens)
    .map(key => {
      const value = tokens[key];
      return value ? `${key}: ${tokens[key]}` : "";
    })
    .filter(item => !!item)
    .join("\n"),
    [tokens]
  );

  const onCopy = useCallback(async () => {
    try {
      await navigator.clipboard.writeText(text);
      notificationStore.addNotification({
        text: "Токены скопированы",
        type: "success",
        options: { autoHideDuration: 2000 }
      });
    } catch (error) {
      notificationStore.addNotification({
        text: "Токены не скопированы. Возникла ошибка",
        type: "error"
      });
    }
  }, [text, notificationStore]);


  const onCancel = useCallback(() => {
    popupStore.closePopup();
  }, [popupStore]);


  return (
    <Box sx={styles.dataWrapper}>
      <Box sx={styles.tokenBox}>
        <Typography>{text}</Typography>
      </Box>

      <Box sx={styles.buttons}>
        <StyledButton onClick={onCancel} variant="outlined">
          Отменить
        </StyledButton>
        <StyledButton startIcon={<ContentCopyIcon />} onClick={onCopy}>
          Копировать
        </StyledButton>
      </Box>
    </Box>
  );
};

export default memo(SellerTokenData);
